import React, { useState } from 'react';

const UseAdmin = () => {
    const [admin, setAdmin] = useState(false)

    return admin;
};

export default UseAdmin;